<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <div class="relative">
      <img
        v-if="icon"
        class="absolute top-2 bottom-2 left-3 sp-icon-position"
        :src="require(`@/assets/icons/${icon}.svg`)"
      />
      <input
        v-bind="field"
        :type="type"
        :name="name"
        :id="name"
        :placeholder="placeholder"
        class="input w-full h-10 box-border px-4 py-3 border rounded leading-4 sp-height"
        :class="{
          'pl-12': icon,
          'border-danger': errorMessage,
        }"
        @blur="onChange"
        @change="onChange"
      />
    </div>

    <BaseErrorMessage v-if="errorMessage" :message="errorMessage" />
  </div>
</template>

<script>
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    BaseFormLabel,
    BaseErrorMessage,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
.input {
  outline: none;

  &:focus {
    border: 1px solid #2cb2b2;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    border-radius: 4px;
  }
}
@media (max-width: 640px) {
  .sp-height {
    height: 48px;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .sp-icon-position {
    top: 12px;
    bottom: 12px;
  }
}
</style>
